import { Route } from '@angular/router';
import { ErrorComponent } from 'src/app/pages/error/error.component';
import { RoutingID } from '../../sb-routing-enum';

export const error: Route = {
  path: 'error',
  component: ErrorComponent,
  title: 'lang.globals.error',
  data: {
    icon: 'error',
    breadcrumb: 'lang.globals.error',
    id: RoutingID.error,
  },
};

export const extError: Route = {
  path: 'error-ext',
  component: ErrorComponent,
  title: 'lang.globals.error',
  data: {
    icon: 'error',
    breadcrumb: 'lang.globals.error',
    id: RoutingID.extError,
  },
};
